import styled, { keyframes } from 'styled-components';

const slide = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const Wrapper = styled.div`
  overflow-x: hidden;
  width: 100%;
  padding: 2rem 0;

  .carousel-wrapper {
    width: 100%;
    overflow-x: hidden;
    position: relative;
  }

  .logo-carousel {
    display: flex;
    animation: ${slide} 30s linear infinite;
    width: max-content;
    flex-wrap: nowrap;

    &:hover {
      animation-play-state: paused;
    }
  }

  .logo-item {
    flex: 0 0 12%;
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: scale(1.15);
      // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    }
  }

  .card {
    background: #fff;
    padding: 1rem;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  img {
    max-height: 60px;
    width: auto;
    object-fit: contain;
  }

  /* Tablet */
  @media (max-width: 992px) {
    .logo-item {
      flex: 0 0 33.33%;
    }
  }

  /* Small tablets / large phones */
  @media (max-width: 768px) {
    .logo-item {
      flex: 0 0 50%;
    }
  }

  /* Phones */
  @media (max-width: 480px) {
    .logo-item {
      flex: 0 0 100%;
    }
  }


  @media (max-width: 768px) {
  .logo-item {
    flex: 0 0 40%; // 2 items visible
  }
}

@media (max-width: 480px) {
  .logo-item {
    flex: 0 0 10%;
  }
}

`;

export default Wrapper;
